import { createContext, useContext, useEffect, useState } from "react";
import { getMe, login as apiLogin, setToken, clearToken, getToken } from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = logged out, obj = logged in
  useEffect(() => {
    if (!getToken()) { setUser(false); return; }
    getMe().then(setUser).catch(() => { clearToken(); setUser(false); });
  }, []);

  const signIn = async (email, password) => {
    const data = await apiLogin(email, password);
    setToken(data.token);
    setUser(data.user);
    return data.user;
  };
  const signOut = () => { clearToken(); setUser(false); };

  return <AuthContext.Provider value={{ user, signIn, signOut }}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);
